import { render, staticRenderFns } from "./AffiliatesTable.vue?vue&type=template&id=2cb593bf&scoped=true&"
import script from "./AffiliatesTable.vue?vue&type=script&lang=js&"
export * from "./AffiliatesTable.vue?vue&type=script&lang=js&"
import style0 from "./AffiliatesTable.vue?vue&type=style&index=0&id=2cb593bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb593bf",
  null
  
)

export default component.exports